import React, {
    createContext,
    useState,
    useEffect,
    useContext,
    ReactNode,
} from "react";
import { Auth } from "aws-amplify";

interface UserContextType {
    user: any | null;
    loading: boolean;
    role: string | null;
    viewPermissions: string[];
    editPermissions: string[];
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [user, setUser] = useState<any | null>(null);
    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState<string | null>(null);
    const [viewPermissions, setViewPermissions] = useState<string[]>([]);
    const [editPermissions, setEditPermissions] = useState<string[]>([]);

    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then((user) => {
                setUser(user?.attributes);
                setRole(user?.attributes["custom:role"] || null);
                setViewPermissions(
                    user?.attributes["custom:view_permissions"]?.split(",") ||
                        []
                );
                setEditPermissions(
                    user?.attributes["custom:edit_permissions"]?.split(",") ||
                        []
                );
            })
            .catch(() => {
                setUser(null);
                setRole(null);
                setViewPermissions([]);
                setEditPermissions([]);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <UserContext.Provider
            value={{ user, loading, role, viewPermissions, editPermissions }}
        >
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return context;
};
